"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ERROR_STYLE = "text-xs text-white font-body bg-red-600 rounded absolute top-100 right-0 mt-1 whitespace-nowrap px-1 z-10";
var Error = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ className: ERROR_STYLE }, { children: children }), void 0));
};
exports.Error = Error;
